import { InnerMediaBlock } from '@prismamedia/one-components';
import { MultimediaPluginButton } from './MultimediaPluginButton';

export const MultimediaPlugin = {
  type: 'multimediaPlugin',
  buttonComponent: MultimediaPluginButton,
  blockComponent: InnerMediaBlock,
};
